import React from 'react';

export default function ActionPlaceHolder() {
  return (
    <div className="card-bg mt-4">
      <div className="text-center py-4">
        <div className="mx-auto mb-4">
          <i className="fas fa-cog text-muted" style={{ fontSize: '2em' }}></i>
        </div>
        <h5 className="card-title mb-2">Ready to Build Your Workflow</h5>
        <p className="card-text text-muted small">Select the workflow trigger to continue</p>
      </div>
    </div>
  );
}
